module.exports = __webpack_public_path__ + "img/man_2_1.1dc7aa69.png";